import { fg } from '@atlaskit/platform-feature-flags';
import type {
	ConfluenceEntityATI,
	EntityATI,
	FederatedEmailEntityAti,
	JiraEntityATI,
	MercuryProductEntityATI,
	PassionfruitEntityATI,
} from '@atlassian/search-client/common/types';

import { DEFAULT_ATLAS_ENTITY_ATI } from './default-atlas-entity-ati';
import { DEFAULT_CONFLUENCE_ENTITY_ATI } from './default-confluence-entity-ati';
import { DEFAULT_MERCURY_ENTITY_ATI } from './default-mercury-entity-ati';
import { DEFAULT_TALENT_ENTITY_ATI } from './default-talent-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_ATLAS_ENTITY_ATI } from './default-atlas-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_MERCURY_ENTITY_ATI } from './default-mercury-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_TALENT_ENTITY_ATI } from './default-talent-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from './default-cloud-graph-document-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI } from './default-cloud-graph-message-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI } from './default-cloud-graph-conversation-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI } from './default-cloud-graph-design-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI } from './default-cloud-graph-video-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI } from './default-cloud-graph-space-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from './default-cloud-graph-comment-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from './default-cloud-graph-work-item-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from './default-cloud-graph-remote-link-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI } from './default-cloud-graph-calendar-event-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI } from './default-cloud-graph-devinfo-repository-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI } from './default-cloud-graph-devinfo-pull-request-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI } from './default-cloud-graph-devinfo-commit-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI } from './default-cloud-graph-devinfo-branch-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI } from './default-cloud-graph-project-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI } from './default-cloud-graph-deal-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI } from './default-cloud-graph-customer-org-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI } from './default-cloud-graph-dashboard-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI } from './default-cloud-graph-data-table-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI } from './default-cloud-graph-customer-contact-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CAMPAIGN_ENTITY_ATI } from './default-cloud-graph-campaign-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CLOUD_GRAPH_CASE_ENTITY_ATI } from './default-cloud-graph-case-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_CONFLUENCE_ENTITY_ATI } from './default-confluence-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { PARITY_CONFLUENCE_ENTITY_ATI } from './parity-confluence-entity-ati';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DEFAULT_SLACK_TYPES } from './default-slack-types';

export const PASSIONFRUIT_ASK_ENTITY_ATI: PassionfruitEntityATI = 'ati:cloud:passionfruit:ask';

export const getMercuryEntityAti = (): MercuryProductEntityATI[] => [
	...DEFAULT_MERCURY_ENTITY_ATI,
	...(fg('platform_passionfruit_search_onboarding_enabled') ? [PASSIONFRUIT_ASK_ENTITY_ATI] : []),
];

export const confluenceEntityATIPrefix = 'ati:cloud:confluence:';

export const CONFLUENCE_CALENDAR_ENTITY_ATI: ConfluenceEntityATI =
	'confluence.com.atlassian.confluence.extra.team-calendars:calendar-content-type';

export const CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI: ConfluenceEntityATI =
	'confluence.com.atlassian.confluence.extra.team-calendars:space-calendars-view-content-type';

export const CONFLUENCE_ANSWER_ENTITY_ATI: ConfluenceEntityATI =
	'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:answer';

export const CONFLUENCE_QUESTION_ENTITY_ATI: ConfluenceEntityATI =
	'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:question';

export const CONFLUENCE_GLIFFY_ENTITY_ATI: ConfluenceEntityATI =
	'confluence.ac:com.gliffy.integration.confluence:gliffy-diagram';

export const JIRA_ISSUE_ENTITY_ATI = 'ati:cloud:jira:issue';
export const JIRA_PROJECT_ENTITY_ATI = 'ati:cloud:jira:project';
export const JIRA_FILTER_ENTITY_ATI = 'ati:cloud:jira:filter';
export const JIRA_DASHBOARD_ENTITY_ATI = 'ati:cloud:jira:dashboard';
export const JIRA_BOARD_ENTITY_ATI = 'ati:cloud:jira:board';
export const JIRA_PLAN_ENTITY_ATI = 'ati:cloud:jira:plan';

export const DEFAULT_JIRA_ENTITY_ATI: JiraEntityATI[] = [
	JIRA_PROJECT_ENTITY_ATI,
	JIRA_ISSUE_ENTITY_ATI,
	JIRA_FILTER_ENTITY_ATI,
	JIRA_DASHBOARD_ENTITY_ATI,
	JIRA_BOARD_ENTITY_ATI,
	JIRA_PLAN_ENTITY_ATI,
	// FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI
];

export const FEDERATED_GOOGLE_EMAIL_ENTITY_ATI = 'ati:third-party:google:email';
export const FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI = 'ati:third-party:microsoft:email';
export const FEDERATED_EMAIL_ENTITY_ATIS: FederatedEmailEntityAti[] = [
	FEDERATED_GOOGLE_EMAIL_ENTITY_ATI,
	FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI,
];

export const getDefaultEntityAti = (): EntityATI[] => [
	...DEFAULT_ATLAS_ENTITY_ATI,
	...DEFAULT_CONFLUENCE_ENTITY_ATI,
	...DEFAULT_JIRA_ENTITY_ATI,
	...getMercuryEntityAti(),
	...DEFAULT_TALENT_ENTITY_ATI,
];

/**
 * Think before bumping the limits as it increases the time spent in the hydration layer.
 * We hydrate quite a few fields from Confluence , Atlas and Jira which can slow downt the calls further.
 */
export const RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS = 15;
export const RESULT_LIMIT_FOR_SINGLE_PRODUCT = 30;
